<template>
  <v-flex xs12 sm12 lg12 xl12 mr-1 ml-1 mt-2>
    <v-card>
      <v-toolbar color="secondary" dark dense>
        <v-toolbar-title>All Your Notifications</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-tabs fixed-tabs>
        <v-tab ripple href="#tab_all">
          All Tasks
        </v-tab>
        <v-tab-item value="tab_all">
          <v-card>
            <v-card-text>
              <div class="display-1">Customer Tasks</div>
              <v-flex xs12>
                <v-layout justify-start>
                  <v-flex xs4>
                    <v-combobox v-model="selectedCustomer" label="Filter by customer" :items="customerList"
                      item-text="Name" item-value="ID" @change="filterbyCustomer()"></v-combobox>
                  </v-flex>
                </v-layout>
                <v-layout justify-end>
                  <v-flex>
                    <v-btn-toggle>
                      <v-btn color="grey" dark @click="filterByStatus('pending')">
                        Pending
                      </v-btn>
                      <v-btn color="orange" dark @click="filterByStatus('in-progress')">
                        In Progress
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-list three-line>
                    <template v-for="(item, index) in customerItems">
                      <v-card elevation="5" :key="index + '-' + item.ID">
                        <v-subheader v-if="item.Type == 1" class="green --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>
                        <!-- <v-subheader v-if="item.Type == 2" class="orange --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader> -->
                        <v-subheader v-if="item.Type == 2" class="red --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>
                        <v-subheader v-if="item.Type == 3" class="blue --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>

                        <v-divider></v-divider>

                        <v-list-tile @click="1==1">
                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.Comments"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.CustomerName"></v-list-tile-sub-title>
                            <v-btn v-if="item.Image != ''" small outline color="secondary" @click="showImage(item)">Show
                              Image</v-btn>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <p><small><b>Change status</b></small></p>
                            <v-btn v-if="item.Status == 1" color="orange" dark @click="UpdateCustomerTaskStatus(item)">
                              In Progress</v-btn>
                            <v-btn v-if="item.Status == 2" color="success" @click="OpenCompleteDialog(item)">Complete
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-card>
                      <v-divider :key="item.StatusName + '-' + item.ID"></v-divider>
                      <!-- <v-dialog v-model="customerResolvedDialog" width="600px" offset-x persistent :key="item.ID">
                        <v-form ref="jobGroupCreationDialog">
                          <v-card>
                            <v-toolbar color="secondary" dark>
                              <v-toolbar-title>Has the task been resolved?</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn icon dark @click="customerResolvedDialog = false">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-toolbar>
                            <v-layout row wrap ma-4>
                              <v-flex xs12 sm12 md12 lg12 xl12>
                                <v-textarea v-model="item.ResolvedComments" label="Please enter comments">
                                </v-textarea>
                              </v-flex>
                            </v-layout>
                            <v-card-actions>
                              <v-layout justify-end>
                                <v-btn color="primary" @click="UpdateCustomerTaskStatus(item)"
                                  :disabled="item.ResolvedComments == null">
                                  Create
                                </v-btn>
                                <v-btn flat @click="customerResolvedDialog = false">
                                  Cancel
                                </v-btn>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-dialog> -->
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
              <br>
              <v-divider></v-divider>
              <br>
              <div class="display-1">Meeting Tasks</div>
              <v-layout>
                <v-flex>
                  <v-list three-line>
                    <template v-for="(item, index) in meetingItems">
                      <v-card elevation="5" :key="index">
                        <v-subheader :key="index" class="blue --darken-2">
                          {{ item.MeetingDetail.Name }} - {{ item.MeetingDetail.Date }}
                        </v-subheader>
                        <v-divider :key="index + '-' + item.MeetingDetail.ID"></v-divider>
                        <v-layout ma-2>
                          <h4>{{ item.MeetingDetail.Subject }}</h4>
                        </v-layout>
                        <v-layout ma-2>
                          <p>{{ item.MeetingDetail.Notes }}</p>
                        </v-layout>
                        <v-layout ma-2>
                          <p v-if="item.MeetingTasks.length > 0"><b>
                              Tasks:</b></p>
                          <p v-else><i>
                              There are no tasks for this meeting</i></p>
                          <v-layout v-for="subItem in item.MeetingTasks" :key="subItem.ID" mt-2>
                            <v-checkbox v-model="subItem.Complete" :label="subItem.Name"
                              @change="completeMeetingTask(subItem)"></v-checkbox>
                          </v-layout>
                          <v-layout justify-end>
                            <v-btn v-if="item.MeetingTasks[0].FilePath != ''" small outline color="secondary"
                              @click="showMeetinImage(item.MeetingTasks[0])">Show
                              Image</v-btn>
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab ripple fixed-tabs href="#tab_customer">
          Customer Tasks
        </v-tab>
        <v-tab-item value="tab_customer">
          <v-card>
            <v-card-text>
              <div class="display-1">Customer Tasks</div>
              <v-flex xs12>
                <v-layout justify-start>
                  <v-flex xs4>
                    <v-combobox v-model="selectedCustomer" label="Filter by customer" :items="customerList"
                      item-text="Name" item-value="ID" @change="filterbyCustomer()"></v-combobox>
                  </v-flex>
                </v-layout>
                <v-layout justify-end>
                  <v-flex>
                    <v-btn-toggle>
                      <v-btn color="grey" dark @click="filterByStatus('pending')">
                        Pending
                      </v-btn>
                      <v-btn color="orange" dark @click="filterByStatus('in-progress')">
                        In Progress
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-list three-line>
                    <template v-for="(item, index) in customerItems">
                      <v-card elevation="5" :key="index + '-' + item.ID">
                        <v-subheader v-if="item.Type == 1" class="green --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>
                        <!-- <v-subheader v-if="item.Type == 2" class="orange --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader> -->
                        <v-subheader v-if="item.Type == 2" class="red --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>
                        <v-subheader v-if="item.Type == 3" class="blue --darken-4">
                          {{ item.TypeName }} - {{ item.DateSent }}
                        </v-subheader>

                        <v-divider></v-divider>

                        <v-list-tile @click="1==1">
                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.Comments"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.CustomerName"></v-list-tile-sub-title>
                            <v-btn v-if="item.Image != ''" small outline color="secondary" @click="showImage(item)">Show
                              Image</v-btn>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-btn :disabled="item.StatusName == 'In Progress'" color="orange" dark
                              @click="UpdateCustomerTaskStatus(item)">In Progress</v-btn>
                            <v-btn :disabled="item.StatusName == 'Complete' || item.StatusName == 'Pending'"
                              color="success" @click="OpenCompleteDialog(item)">Complete</v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-card>
                      <v-divider :key="item.TypeName + '-' + item.ID"></v-divider>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab ripple fixed-tabs href="#tab_meeting">
          Meeting Tasks
        </v-tab>
        <v-tab-item value="tab_meeting">
          <v-card>
            <v-card-text>
              <div class="display-1">Meeting Tasks</div>
              <v-layout>
                <v-flex>
                  <v-list three-line>
                    <template v-for="(item, index) in meetingItems">
                      <v-card elevation="5" :key="index">
                        <v-subheader :key="index" class="blue --darken-2">
                          {{ item.MeetingDetail.Name }} - {{ item.MeetingDetail.Date }}
                        </v-subheader>
                        <v-divider :key="index + '-' + item.MeetingDetail.ID"></v-divider>
                        <v-layout ma-2>
                          <h4>{{ item.MeetingDetail.Subject }}</h4>
                        </v-layout>
                        <v-layout ma-2>
                          <p>{{ item.MeetingDetail.Notes }}</p>
                        </v-layout>
                        <v-layout ma-2>
                          <p v-if="item.MeetingTasks.length > 0"><b>
                              Tasks:</b></p>
                          <p v-else><i>
                              There are no tasks for this meeting</i></p>
                          <v-layout v-for="subItem in item.MeetingTasks" :key="subItem.ID" mt-2>
                            <v-checkbox v-model="subItem.Complete" :label="subItem.Name"
                              @change="completeMeetingTask(subItem)"></v-checkbox>
                          </v-layout>

                        </v-layout>
                      </v-card>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-layout v-if="1==2">
        <v-flex xs12 sm12 lg12 xl12 mr-1 ml-1 mt-2>
          <v-card elevation="3">
            <v-layout justfy-start ma-3 row wrap>
              <v-flex xs4>
                <v-select label="Select feedback type" v-model="selectedFeedback" :items="FeedbackTypes"
                  item-text="Name" item-value="ID" @change="filterByFeedback()"></v-select>
              </v-flex>
            </v-layout>
            <v-data-table :headers="headers" :items="customerItems" :search="search"
              :rows-per-page-items="[25,50,75,100]">
              <template slot="no-data">There are no records</template>
              <template slot="no-results">No matching records found</template>
              <template slot="headerCell" slot-scope="{ header }">
                <span class="subheading font-weight-light text-success text--darken-3" v-text="header.text" />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td>{{ item.DateSent }}</td>
                <td>{{ item.CustomerName }}</td>
                <td>{{ item.Comments }}</td>
                <td>{{ item.StatusName }}</td>
                <td style="float:right;">
                  <v-menu dense bottom left>
                    <v-btn small slot="activator" color="primary" dark>
                      <v-icon>settings</v-icon>
                    </v-btn>
                    <div
                      v-if="HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY') || HasAccess('CUSTOMER_MANAGEMENT', 'DELETE')">
                      <v-list dense v-for="(action, index) in actionItems" :key="index">
                        <v-list-tile @click="PerformOperation(action, item)" v-if="action.access == true">
                          <v-list-tile-action>
                            <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                    <div v-else>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-title>
                            You have no options
                            available
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="showImageDialog" width="600px">
      <v-layout row wrap fill-height justify-center>
        <v-flex>
          <v-card>
            <v-img :src="photo">
            </v-img>
            <v-layout fill-width justify-center>
              <a :href="photo" :download="'download.png'">
                <v-btn color="primary" @click="showImageDialog = false">
                  Download
                </v-btn>
              </a>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="showPhoto" max-width="500px">
      <v-flex xs12>
        <v-card>
          <v-layout fill-height>
            <v-img v-if="photoUrl != null" :src="photoUrl"></v-img>
          </v-layout>
        </v-card>
      </v-flex>
    </v-dialog>
    <v-dialog v-model="customerResolvedDialog" width="600px" offset-x persistent>
      <v-form ref="jobGroupCreationDialog">
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>Has the task been resolved?</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="customerResolvedDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout row wrap ma-4>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-textarea v-model="tmpItem.ResolvedComments" label="Please enter comments">
              </v-textarea>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-end>
              <v-btn color="primary" @click="UpdateCustomerTaskStatus(tmpItem)"
                :disabled="tmpItem.ResolvedComments == null">
                OK
              </v-btn>
              <v-btn flat @click="customerResolvedDialog = false">
                Cancel
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-flex>
</template>

<script>
  import JWT from "jsonwebtoken";
  import moment from "moment";
  export default {
    data() {
      let self = this;
      return {
        showPhoto: false,
        photoUrl: "",
        showImageDialog: false,
        customerResolvedDialog: false,
        photo: "",
        tmpItem: [],
        meetingItems: [],
        customerItems: [],
        customerList: [],
        selectedCustomer: null,
        statusToggle: true,
        userID: 0,
        role: null,
        selectedFeedback: 0,
        ResolvedComments: null,
        FeedbackTypes: [{
            ID: 1,
            Name: "Request"
          },
          {
            ID: 2,
            Name: "Complaint"
          }, {
            ID: 3,
            Name: "Compliment"
          }
        ],
        actionItems: [{
            type: "modify",
            title: "Modify",
            access: self.HasAccess("CUSTOMER_MANAGEMENT", "MODIFY"),
            icon: "edit"
          },
          {
            type: "delete",
            title: "Delete",
            access: self.HasAccess("CUSTOMER_MANAGEMENT", "DELETE"),
            icon: "delete"
          }
        ],
        headers: [{
            sortable: true,
            text: "Date Sent",
            value: "DateSent"
          },
          {
            sortable: true,
            text: "Customer",
            value: "CustomerName"
          },
          {
            sortable: true,
            text: "Comments",
            value: "Comments"
          },
          {
            sortable: true,
            text: "Status",
            value: "StatusName"
          },
          {
            sortable: false,
            align: "right",
            text: "Actions"
          }
        ],
        tmpItems: []
      }
    },
    props: {
      search: String
    },
    mounted() {
      let self = this;

      self.userID = localStorage.getItem("USER_ID");
      self.roleID = localStorage.getItem("RoleID");
      console.log("USER_ID", self.userID)
      console.log("ROLE_ID", self.roleID);
      self.GetFeedbackByLoggedInUser();
      self.GetCustomers();
      self.FetchMeetingTasks();
    },
    methods: {
      // GetFeedbackbyRole() { // CUSTOMER TASKS
      //   let self = this;

      //   if (self.$store.getters.getUserSessionData.Role.Master == true) {
      //     self.get(`CustomerFeedbackTask`).then(response => {
      //       response.data.forEach(task => {
      //         task.DateSent = moment(task).format("YYYY-MM-DD")
      //       })
      //       self.customerItems = response.data;
      //       self.tmpItems = response.data;
      //       console.log("[CUST-FEEDBACK]", self.customerItems)
      //     })
      //   } else {
      //     self.get(`CustomerFeedbackTask/GetByRole?roleID=${self.roleID}`).then(r => {
      //       r.data.forEach(task => {
      //         task.DateSent = moment(task).format("YYYY-MM-DD")
      //       })
      //       self.customerItems = r.data;
      //       self.tmpItems = r.data;
      //       console.log("[CUST-FEEDBACK]", self.customerItems)
      //     })
      //   }
      // },
      GetFeedbackByLoggedInUser() {
        let self = this;

        self.get(`CustomerFeedbackTask/GetByUser?userID=${self.userID}`).then(r => {
          r.data.forEach(task => {
            task.DateSent = moment(task).format("YYYY-MM-DD")
          })

          self.customerItems = r.data;
          self.tmpItems = r.data;
          console.log("[CUST-FEEDBACK]", self.customerItems)
        })
      },
      GetCustomers() {
        let self = this;
        let url;

        switch (self.roleID) {
          case "1": {
            url = `Customer`;
          }
          break;
        case "2": {
          url = `Customer`;
        }
        break;
        default: {
          url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
        }
        break;
        }

        self.get(url)
          .then(response => {
            console.log("CUSTOMER LIST", response)
            self.customerList = response.data;
            //console.log(self.customerList);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });

      },
      FetchMeetingTasks() {
        let self = this;
        self.meetingItems = []
        self.get(`Meeting/GetAllComplex?systemUserID=${self.userID}`).then(r => {
          console.log("[MEETING STUFF FOR THIS USER]", r.data)
          r.data.forEach(meeting => {
            if (meeting.MeetingSystemUsers.length != 0) {
              meeting.MeetingDetail.Date = moment(meeting.MeetingDetail.Date).format("YYYY-MM-DD HH:mm:ss")
              self.meetingItems.push(meeting)
            }
          })
          // self.meetingItems = r.data;
        })
      },
      filterbyCustomer() {
        let self = this;
        self.customerItems = [];

        self.$nextTick(() => {
          console.log("SELECTED CUSTOMER", self.selectedCustomer);
          self.tmpItems.forEach(feedback => {
            if (self.selectedCustomer.ID == feedback.CustomerID) {
              self.customerItems.push(feedback);
            }
          })
        })
      },
      filterByStatus(status) {
        let self = this;
        self.customerItems = [];

        console.log("STATUS", status);

        self.$nextTick(() => {
          if (status == 'pending') {
            self.tmpItems.forEach(feedback => {
              if (feedback.Status == 1) {
                self.customerItems.push(feedback);
              }
            })
          } else if (status == 'in-progress') {
            self.tmpItems.forEach(fdBack => {
              if (fdBack.Status == 2) {
                self.customerItems.push(fdBack)
              }
            })
          }
        })
      },
      filterByFeedback() {
        let self = this;
        self.customerItems = [];

        self.$nextTick(() => {
          console.log("selected feedback", self.selectedFeedback)

          self.tmpItems.forEach(feedback => {
            if (feedback.Type == self.selectedFeedback) {
              self.customerItems.push(feedback);
            }
          })
        })
      },
      OpenCompleteDialog(item) {
        let self = this;
        console.log(item);
        self.tmpItem = item;
        self.$nextTick(() => {
          self.customerResolvedDialog = true;
        })
      },
      UpdateCustomerTaskStatus(item) {
        let self = this;
        item.Status = item.Status + 1;

        if (item.Status == 3) {
          item.DateResolved = moment().toDate();
        }
        self.$nextTick(() => {
          console.log("UPDATE CUSTOMER TASK", item)

          self.put(`CustomerFeedbackTask?id=${item.ID}`, item).then(r => {
              console.log("status changed", r.data);
              self.tmpItem = []
              self.customerResolvedDialog = false;
              self.GetFeedbackByLoggedInUser();
            })
            .catch(e => {
              console.error(e);
            })
        })
      },
      completeMeetingTask(subItem) {
        let self = this;

        console.log("MEETING TASK SELECTED", subItem);

        self.put(`MeetingTask?id=${subItem.ID}`, subItem).then(r => {
          console.log("COMPLETED MEETING TASK", r.data)
          self.FetchMeetingTasks();
        })
      },
      showImage(item) {
        let self = this;

        console.log("SHOW IMAGE", item)
        self.$nextTick(() => {
          self.showImageDialog = true;
          self.photo = "data:image/png;base64," + item.Image;
        })
      },
      showMeetinImage(item) {
        let self = this;

        self.showPhoto = true;
        console.log("show image", item)

        let address = self.$Config.ServerAddress;
        //console.log("address", address);
        self.photoUrl = `${address}Photo/Stream/Meeting?id=${item.ID}`;
      }
    },
  }
</script>

<style scoped>
  .task-header {
    width: 100%;
    height: 100%;
  }
</style>